import { Box, Typography, useTheme } from "@mui/material";
import data from "../../helpers/DataHelper";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ProjectsList(props) {

  const {
    projectToHide
  } = props;

  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      mb: "80px"
    }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderTop: `1px solid ${theme.palette.divider}`,
          order: 0,
          [theme.breakpoints.down('md')]: {
            order: 1,
          }
        }}>
        {
          Object.keys(data.projects).map((key, index) => {
            if (key !== projectToHide) {

              return (
                <Link to={process.env.PUBLIC_URL + "/" + key} style={{
                  textDecoration: "none",
                  color: theme.palette.text.primary
                }}
                  onClick={() => { window.scrollTo(0, 0) }}
                  key={key + "_" + index}
                >
                  <Box
                    sx={{
                      display: "flex",
                      p: 2,
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      cursor: "pointer",
                      transition: "background 0.3s ease-in-out",
                      alignItems: "center",
                      "svg": {
                        opacity: 0,
                        color: theme.palette.divider,
                        transition: "all 0.3s ease-in-out",
                      },
                      "&:hover": {
                        background: theme.palette.action.hover,
                        "svg":
                        {
                          opacity: 1,
                          "&.arrow": {
                            transform: "translateX(-8px)",
                          }
                        }
                      }
                    }}
                  >
                    <Typography variant="h3" sx={{
                      ml: "24px",
                      [theme.breakpoints.down('md')]: {
                        ml: "8px",
                      }
                    }}>{t(data.projects[key].title)}</Typography>
                    <ArrowBackIcon
                    fontSize="large"
                    className="arrow"
                    sx={{
                      fill: theme.palette.text.primary,
                      ml: "8px",
                      mt: "4px",
                      [theme.breakpoints.down('md')]: {
                       display: "none",
                      }
                    }}/>

                    <OpenInNewIcon sx={{
                      marginLeft: "auto",
                      mr: "24px",
                      [theme.breakpoints.down('md')]: {
                        mr: "8px",
                      }
                    }} fontSize="large" />
                  </Box>
                </Link>
              )
            }
            else {
              return null
            }
          })
        }
      </Box>
      <Box sx={{
        p: 2,
      }}>
        <Typography variant="h3" sx={{
          ml: "24px",
          order: 1,
          ".arrow-down": {
              display: "none",
          },
          [theme.breakpoints.down('md')]: {
            ml: "8px",
            order: 0,
            ".arrow-up": {
              display: "none",
            },
            ".arrow-down": {
              display: "inline-block",
          },
          }
        }}><strong>{t("label_other_projects")} <span className="arrow-up">⤴</span><span className="arrow-down">⤵</span></strong></Typography>
      </Box>
    </Box>
  )
}
